import styled from "styled-components";

const SShowsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 10px;

	@media screen and (min-width: 640px) {
		margin-top: 15px;
	}
`;

export default SShowsContainer;